import React, { useRef } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Table } from 'antd';
// actions
import groupsAction from '../../../../../redux/actions/groups';
// configs
import { columns } from './column';
import useDidMountEffect from '../../../../../configs/hooks/useDidMountEffect';
// types
import { stateType } from '../../../../../types/types';
// style
import './../../style.scss';

const GroupsTable: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const scrollToRef = useRef<any>();

  const loader = useSelector((state: stateType) => state.groups.loader, shallowEqual);
  const items = useSelector((state: stateType) => state.groups.items, shallowEqual);
  const params = useSelector((state: stateType) => state.groups.params, shallowEqual);
  const count = useSelector((state: stateType) => state.groups.count, shallowEqual);
  const rowI = useSelector((state: stateType) => state.groups.rowIndex, shallowEqual);

  useDidMountEffect(() => {
    if (items.length && scrollToRef.current) {
      scrollToRef.current.scrollIntoView();
      groupsAction.rowIndex(undefined);
    }
  }, [loader]);

  return (
    <Table
      rowKey={'id'}
      className="clients-table"
      columns={columns}
      dataSource={loader ? undefined : items}
      loading={loader}
      scroll={{ y: 570 }}
      locale={{ emptyText: <div> </div> }}
      pagination={{
        style: { visibility: `${count <= 10 ? 'hidden' : 'visible'}` },
        size: 'small',
        showQuickJumper: true,
        defaultPageSize: 10,
        pageSize: params.per_page,
        current: params.page,
        total: count,
        pageSizeOptions: ['10', '20', '25', '30', '50', '100'],
        position: ['bottomCenter'],
        onChange: async (page, pageSize) => {
          try {
            await groupsAction.params({ ...params, page: page, per_page: pageSize });
            dispatch(groupsAction.get());
          } catch (e) {
            console.log(e);
          }
        },
      }}
      onRow={(record, rowIndex) => {
        return {
          ref: rowIndex === rowI ? scrollToRef : undefined,
          onClick: () => {
            history.push(`/groups/${record.id}`);
            groupsAction.rowIndex(rowIndex);
          },
        };
      }}
    />
  );
};

export default GroupsTable;
